import React, { useState, useEffect } from 'react';
import './App.css';
import { LogOut, AlertTriangle, X } from 'lucide-react'; // Icons for better look
import Login from './Login/Login';
import Sidebar from './Dashboard/Sidebar';
import DashboardContent from './Dashboard/DashboardContent';
import NewInsurance from './Vehicles/NewInsurance';
import VehicleReport from './Reports/VehicleReport';
import ComboVehicleEntry from './Vehicles/ComboVehicleEntry';
import ExpiryAnalysis from './Reports/ExpiryAnalysis';
import BillForm from './Account/BillForm';
import BillReport from './Reports/BillReport';
import PaymentIn from './Account/PaymentIn';
import PaymentInReport from './Reports/PaymentInReport';
import PartyReport from './Reports/PartyReport';
import LedgerEntry from './Ledger/LedgerEntry';
import LedgerReport from './Reports/LedgerReport';
import PaymentList from './Account/PaymentList';
import AppLogo from './Logo.png';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const savedStatus = sessionStorage.getItem('isLoggedIn');
    return savedStatus === 'true';
  });

  const [activePage, setActivePage] = useState(() => {
    return sessionStorage.getItem('activePage') || 'dashboard';
  });

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // --- Naya State: Logout Modal Control ---
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const [editVehicleNo, setEditVehicleNo] = useState(null);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    sessionStorage.setItem('isLoggedIn', isLoggedIn);
    sessionStorage.setItem('activePage', activePage);
  }, [isLoggedIn, activePage]);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    setActivePage('dashboard');
  };

  // --- LOGOUT LOGIC ---
  const confirmLogout = () => {
    setIsLoggedIn(false);
    setActivePage('dashboard');
    sessionStorage.clear();
    localStorage.clear();
    window.location.reload();
  };

  const handleNavigation = (menuItem, id = null) => {
    if (menuItem === 'edit-insurance') {
      setEditVehicleNo(id);
    } else if (menuItem === 'edit-payment' || menuItem === 'edit-receipt' || menuItem === 'edit-ledger') {
      setEditId(id);
    } else {
      setEditVehicleNo(null);
      setEditId(null);
    }
    setActivePage(menuItem);
  };

  const pageTitles = {
    dashboard: "Dashboard",
    "ledger-entry": "Party Ledger",
    "ledger-list": "Ledger List",
    "new-entry": "Add Vehicle",
    "insurance-report": "Vehicle List",
    "payment-entry": "Create Bill",
    "bill-report": "Bill List",
    "payment-in": "Payment Entry",
    "payment-list": "Payment List",
    "payment-in-report": "Payment Report",
    "party-report": "Party Report",
    "expiry-analysis": "Expiry Analysis",
    "whatsapp-msg": "WhatsApp Message",
    "edit-insurance": "Edit Vehicle",
    "edit-payment": "Edit Bill",
    "edit-receipt": "Edit Receipt",
    "edit-ledger": "Edit Ledger"
  };

  const renderPage = () => {
    switch (activePage) {
      case 'dashboard': return <DashboardContent />;
      case 'new-entry': return <NewInsurance onBack={() => handleNavigation('dashboard')} />;
      case 'edit-insurance': return <NewInsurance editMode={true} vehicleNo={editVehicleNo} onBack={() => handleNavigation('insurance-report')} />;
      case 'insurance-report': return <VehicleReport onEdit={(vNo) => handleNavigation('edit-insurance', vNo)} />;
      case 'payment-entry': return <BillForm onBack={() => handleNavigation('dashboard')} />;
      case 'edit-payment': return <BillForm editMode={true} paymentId={editId} onBack={() => handleNavigation('bill-report')} />;
      case 'bill-report': return <BillReport onEdit={(id) => handleNavigation('edit-payment', id)} />;
      case 'payment-in': return <PaymentIn onBack={() => handleNavigation('dashboard')} />;
      case 'edit-receipt': return <PaymentIn editMode={true} receiptId={editId} onBack={() => handleNavigation('payment-in-report')} />;
      case 'payment-in-report': return <PaymentInReport onEdit={(id) => handleNavigation('edit-receipt', id)} />;
      case 'expiry-analysis': return <ExpiryAnalysis onEdit={(vNo) => handleNavigation('edit-insurance', vNo)} />;
      case 'party-report': return <PartyReport onEdit={(id) => handleNavigation('edit-receipt', id)} />;
      case 'combo-entry': return <ComboVehicleEntry />;
      case 'whatsapp-msg': return <div className="placeholder"><h2>💬 WhatsApp Panel</h2><p>Feature under development...</p></div>;
      case 'ledger-entry': return <LedgerEntry onBack={() => handleNavigation('dashboard')} />;
      case 'edit-ledger': return <LedgerEntry editMode={true} ledgerId={editId} onBack={() => handleNavigation('ledger-list')} />;
      case 'ledger-list': return <LedgerReport onEdit={(id) => handleNavigation('edit-ledger', id)} />;
      case 'payment-list': return <PaymentList />;
      default: return <DashboardContent />;
    }
  };

  if (!isLoggedIn) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  return (

    <div className="app-layout">

      {/* Mobile Header */}
      <div className="mobile-header">
        <img
          src={AppLogo}
          alt="RTO"
          className="header-logo"
        />

        <h3 className="header-title">
          {pageTitles[activePage] || "Dashboard"}
        </h3>

        <button
          className="header-menu-btn"
          onClick={toggleSidebar}
        >
          {sidebarOpen ? "✕" : "☰"}
        </button>
      </div>

      <Sidebar
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
        onMenuClick={handleNavigation}
        onLogout={() => setShowLogoutModal(true)}
        activePage={activePage}
      />

      <main className="content-area">
        {renderPage()}
      </main>

      {/* --- 🔥 CUSTOM PREMIUM LOGOUT MODAL --- */}
      {showLogoutModal && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-card">
            <button className="modal-close-btn" onClick={() => setShowLogoutModal(false)}>
              <X size={20} />
            </button>

            <div className="modal-icon-wrapper">
              <div className="icon-pulse"></div>
              <LogOut size={40} color="#ef4444" />
            </div>

            <h3>Logout Confirm Karein?</h3>
            <p>DK RTO System se baahar jaane ke liye "Confirm" par click karein.</p>

            <div className="modal-actions">
              <button className="modal-btn btn-cancel" onClick={() => setShowLogoutModal(false)}>
                Nahi, Ruko
              </button>
              <button className="modal-btn btn-confirm" onClick={confirmLogout}>
                Confirm Logout
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        /* MODAL STYLING */
        .custom-modal-overlay {
          position: fixed;
          top: 0; left: 0; width: 100%; height: 100%;
          background: rgba(15, 23, 42, 0.7); /* Dark Blur Effect */
          backdrop-filter: blur(8px);
          display: flex; align-items: center; justify-content: center;
          z-index: 9999;
          animation: fadeIn 0.3s ease;
        }

        .custom-modal-card {
          background: white;
          width: 90%; max-width: 400px;
          padding: 40px 30px;
          border-radius: 24px;
          text-align: center;
          position: relative;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
          animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { transform: translateY(30px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

        .modal-icon-wrapper {
          position: relative;
          width: 80px; height: 80px;
          background: #fee2e2;
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          margin: 0 auto 20px;
        }

        .icon-pulse {
          position: absolute;
          width: 100%; height: 100%;
          border-radius: 50%;
          background: #fee2e2;
          animation: pulse 2s infinite;
          z-index: -1;
        }

        @keyframes pulse {
          0% { transform: scale(1); opacity: 0.8; }
          100% { transform: scale(1.6); opacity: 0; }
        }

        .custom-modal-card h3 { margin: 0 0 10px; color: #1e293b; font-size: 22px; font-weight: 800; }
        .custom-modal-card p { color: #64748b; font-size: 15px; margin-bottom: 30px; line-height: 1.5; }

        .modal-actions { display: flex; gap: 12px; }
        .modal-btn {
          flex: 1; padding: 12px; border-radius: 12px; font-weight: 700; cursor: pointer;
          transition: all 0.2s; border: none; font-size: 14px;
        }

        .btn-cancel { background: #f1f5f9; color: #475569; }
        .btn-cancel:hover { background: #e2e8f0; }

        .btn-confirm { background: #ef4444; color: white; box-shadow: 0 4px 10px rgba(239, 68, 68, 0.3); }
        .btn-confirm:hover { background: #dc2626; transform: translateY(-2px); }

        .modal-close-btn {
          position: absolute; top: 15px; right: 15px;
          background: none; border: none; color: #94a3b8; cursor: pointer;
        }

        .mobile-header {
  display: none;
}

@media (max-width:768px){

  .mobile-header{
    display:flex;
    align-items:center;
    justify-content:space-between;
    position:fixed;
    top:0;
    left:0;
    right:0;
    height:60px;
    background:#fff;
    padding:0 15px;
    z-index:2000;
    box-shadow:0 2px 10px rgba(0,0,0,.1);
  }

  .header-logo{
    width:40px;
    height:40px;
    object-fit:contain;
  }

  .header-title{
    flex:1;
    text-align:center;
    margin:85px;
    font-size:16px;
    font-weight:700;
  }

  .header-menu-btn{
    border:none;
    background:none;
    font-size:24px;
    cursor:pointer;
    width:40px;
  }

  .content-area{
    margin-top:60px;
  }
}
      `}</style>
    </div>
  );
}

export default App;